<template>
	<transition name="bounce">
		<div
			class="alert_banner"
			v-if="
        this.$store.state.alert_bar_closed != true && (parsedLink || alert_banner_text)"
		>
			<div class="container">
				<div class="inner">
					<p
						v-if="alert_banner_text"
						v-html="alert_banner_text"
					></p>
					<a
						v-if='parsedLink'
						:href="parsedLink.url"
						:target="parsedLink.target"
						v-html="parsedLink.title"
					></a>

					<div
						class="close_image"
						@click="closeAlertBar"
					>
						<svg
							width="18"
							height="18"
							viewBox="0 0 18 18"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M8.70703 10.1213L15.9998 17.4141L17.4141 15.9999L10.1212 8.70709L17.4142 1.41412L16 -9.15527e-05L8.70703 7.29288L1.41406 -9.15527e-05L-0.000152588 1.41412L7.29282 8.70709L0 15.9999L1.41421 17.4141L8.70703 10.1213Z"
								fill="#203136"
							/>
						</svg>

					</div>
				</div>

			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		toggle_alert_banner: {},
		alert_banner_text: {},
		alert_banner_link: {},
		alert_banner_id: {},
	},

	computed: {
		parsedLink() {
			if (this.alert_banner_link) {
				return JSON.parse(this.alert_banner_link);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		closeAlertBar() {
			this.$store.commit('closeAlertBar', true);
			this.$store.commit('alertBarID', this.alert_banner_id);
			location.reload();
		},
		openAlertBar() {
			this.$store.commit('closeAlertBar', false);
		},
	},

	components: {},

	created() {},
	mounted() {
		if (this.$store.state.alert_bar_id === false) {
			this.$store.commit('alertBarID', this.alert_banner_id);
		}

		if (this.$store.state.alert_bar_id != this.alert_banner_id) {
			this.openAlertBar();
		}
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.alert_banner {
	background: var(--light-grey);
	position: relative;
	z-index: 999;

	.container {
		.inner {
			grid-column: span 12;
			display: inline-flex;
			justify-content: flex-start;
			align-items: center;
			position: relative;
			padding: 8px 0;

			@media (max-width: $mobile) {
				grid-column: span 4;
				width: 100%;
				align-items: flex-start;
				flex-direction: column;
				padding: 16px 0;
			}

			p {
				font: normal normal normal 14px/20px var(--primary-font-family);
				color: var(--midnight);
				margin: 0;

				@media (max-width: $mobile) {
					max-width: 75%;
				}
			}

			a {
				font: normal normal normal 14px/20px var(--primary-font-family);
				color: var(--midnight);
				margin: 0;
				position: relative;
				display: inline-flex;
				align-items: center;

				@media (max-width: $mobile) {
					max-width: 50%;
					font-weight: bold;
				}

				&::before {
					position: relative;
					width: 1px;
					height: 16px;
					border-radius: 50%;
					content: '';
					background: var(--midnight);
					display: inline-flex;
					margin: 0 24px;

					@media (max-width: $mobile) {
						display: none;
					}
				}
			}

			.close_image {
				display: flex;
				position: absolute;
				right: 0;

				@media (min-width: $mobile) {
					width: 24px;
					height: 24px;
					background: var(--navy);
					border-radius: 50%;
					justify-content: center;
					align-items: center;
					transition: 0.2s ease all;

					&:hover {
						cursor: pointer;
						/* background: var(--fpe-blue);
						transition: 0.2s ease all; */

						/* svg {
							width: 8px;

							line {
								stroke: var(--midnight);
								stroke-width: 5px;
							}
						} */
					}

					/* svg {
						width: 8px;

						line {
							stroke: var(--midnight);
							stroke-width: 5px;
						}
					} */
				}
			}
		}
	}
}

.bounce-enter-active {
	animation: bounce-in 0.15s;
}

.bounce-leave-active {
	animation: bounce-in 0.15s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(-100px);
		opacity: 0;
	}
	// 50% {
	// 	transform: translateY(30px);
	// 	opacity: 1;
	// }
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AlertBanner.vue